module.exports = __webpack_public_path__ + "img/awards_image_03.0bfeadee.jpg";